import axios from "./apiClient";

export const login = async (credentials: {
    email: string;
    password: string;
}) => {
    const params = new URLSearchParams();
    params.append("username", credentials.email);
    params.append("password", credentials.password);

    const response = await axios.post(
        "/users/token",
        params,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
    );

    if (response.data.access_token) {
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("sessionStartTime", Date.now().toString());
    }

    return response.data;
};

export const validateToken = async (token: string) => {
    const response = await axios.post("/auth/validate-token", { token });
    if (response.data.access_token) {
        localStorage.setItem("token", response.data.access_token);
        localStorage.setItem("sessionStartTime", Date.now().toString());
    }
    return response.data;
};

export const getCurrentUser = async (token?: string | null) => {
    // Don't make request if no token provided
    if (!token) {
        throw new Error("No authentication token provided");
    }

    const response = await axios.get("/users/me", {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });

    return response.data;
};

export const getStoredToken = (): string | null => {
    if (typeof window === "undefined") return null;

    return localStorage.getItem("token");
};

export const clearStoredToken = (): void => {
    if (typeof window === "undefined") return;

    localStorage.removeItem("token");
};

export const checkSession = (): string | null => {
    const token = localStorage.getItem("token");
    const sessionStartTime = localStorage.getItem("sessionStartTime");

    if (token && sessionStartTime) {
        const startTime = parseInt(sessionStartTime, 10);
        const thirtyMinutes = 30 * 60 * 1000;

        if (Date.now() - startTime < thirtyMinutes) {
            return token;
        }
    }

    clearStoredToken();
    localStorage.removeItem("sessionStartTime");
    return null;
};
